import { Avatar, Button } from '@material-ui/core';
import { useStyles } from '@webapps/styles';

const InfoCandidat = () => {
  const { classes } = useStyles(styles);

  return (
    <di>
      <div className={classes.head}>
        <Avatar className={classes.avatar} />
        <div className={classes.blocName}>
          <div>Arnaud Bichi</div>
          <div>13004 Marseille</div>
          <div>Coordonnées</div>
          <div>En recherche pour: Trouver une alternance</div>
        </div>
      </div>
      <div className={classes.blocBtn}>
        <Button color="primary" fullWidth variant="contained">
          Message
        </Button>
      </div>
      <div className={classes.blocApropos}>
        <div className={classes.apropos}>A propos</div>
        <div>
          Je me présente Arnaud Bichi, 18 ans, diplômé en BAC Pro SEN (Système
          Électronique et Numérique) ...
        </div>
      </div>
      <div className={classes.blocExperience}>
        <div className={classes.expTitle}>Expérience (4)</div>
        <div className={classes.itemExperience}>
          <Avatar className={classes.avatar} />
          <div className={classes.expDetails}>
            <div>Technicien Informatique</div>
            <div>Byos Informatique</div>
            <div>Marseille (13)</div>
            <div>En stage - septembre 2015 à juin 2018</div>
          </div>
        </div>
      </div>
      <div className={classes.blocExperience}>
        <div className={classes.expTitle}>Formation (4)</div>
        <div className={classes.itemExperience}>
          <Avatar className={classes.avatar} />
          <div className={classes.expDetails}>
            <div>Technicien Informatique</div>
            <div>Byos Informatique</div>
            <div>Marseille (13)</div>
            <div>En stage - septembre 2015 à juin 2018</div>
          </div>
        </div>
      </div>
    </di>
  );
};

const styles = ({ spacing }) => ({
  avatar: {
    height: 100,
    width: 100,
  },
  head: {
    display: 'flex',
    alignItems: 'center',
  },
  blocName: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: spacing(2),
  },
  blocBtn: {
    marginTop: spacing(2),
  },
  blocApropos: { marginTop: spacing(2) },
  apropos: { marginTop: spacing(2) },
  blocExperience: { marginTop: spacing(2) },
  itemExperience: { marginTop: spacing(1), display: 'flex' },
  expDetails: { marginLeft: spacing(2) },
});

export default InfoCandidat;
